import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import Wizard from "./stepper";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";
import Step4 from "./step4";
import Step5 from "./step5";
import Step6 from "./step6";
import "./Signup.css";
import { Redirect } from "react-router-dom";
import { Button, Loader } from "semantic-ui-react";
import Verify from "../../images/email-verification.svg";
import { resendVerfication } from "../../store/actions/newSignup";

const Signup = (props) => {
  let returnObj = null;
  // ** State
  const [showComponent, setShowComponent] = useState(false);
  const guidedRef = useRef(null);
  const [guidedStepper, setGuidedStepper] = useState(null);
  const [plans, setPlans] = useState([]);
  const [id, setId] = useState(null);
  const [mainUrl, setMainUrl] = useState(null);
  const [secondUrl, setSecondUrl] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [classYear, setClass] = useState(null);
  const [newUser, setNewUser] = useState(null);
  const [paymentType, setPaymentType] = useState(null);
  const [paymentDone, setPaymentDone] = useState(false);
  const [paymentRefund, setPaymentRefund] = useState(false);
  const [status, setStatus] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      setShowComponent(true);
    }, 3400);
  }, []);

  useEffect(() => {
    let SignUpRequest;

    if (
      props.newRequestCollection &&
      Object.keys(props.newRequestCollection).length > 0 &&
      props.auth.uid &&
      props.priceList.length > 0
    ) {
      setId(props.auth.uid);

      if (Object.keys(props.newRequestCollection[props.auth.uid]).length > 0) {
        SignUpRequest = props.newRequestCollection[props.auth.uid];
        setNewUser(SignUpRequest);
        setClass(SignUpRequest.classYear);

        if (SignUpRequest.mainAgreementUrl) {
          setMainUrl(SignUpRequest.mainAgreementUrl);
        }

        if (SignUpRequest.secondAgreementUrl) {
          setSecondUrl(SignUpRequest.secondAgreementUrl);
        }

        if (
          SignUpRequest.customerType === "student" &&
          SignUpRequest.classYear
        ) {
          setClass(SignUpRequest.classYear);
          const filteredArray = props.priceList.filter(
            (e) => !e.collegeTransfer
          );
          const filteredPlans = filteredArray.filter(
            (plan) =>
              (plan.show && plan.classYear < SignUpRequest.classYear) ||
              plan.otp
          );
          setPlans(filteredPlans);
        }

        if (SignUpRequest.customerType === "transfer") {
          const filteredPlans = props.priceList.filter(
            (plan) => plan.collegeTransfer
          );
          setPlans(filteredPlans);
        }

        if (SignUpRequest.selectedPlan) {
          props.priceList.forEach((plan) => {
            if (plan.planId === SignUpRequest.selectedPlan) {
              setSelectedPlan(plan);
            }
          });
        }

        if (SignUpRequest.paymentMethod) {
          setPaymentType(SignUpRequest.paymentMethod);
        }
        if (SignUpRequest.paymentDone) {
          setPaymentDone(SignUpRequest.paymentDone);
        } else setPaymentDone(false);

        if (SignUpRequest.refund) {
          setPaymentRefund(SignUpRequest.refund);
        } else setPaymentRefund(false);
        if (SignUpRequest) {
          setStatus(SignUpRequest.status);
        }
      }
    }
  }, [props.auth.uid, props.newRequestCollection, props.priceList]);

  // guided step
  let guidedSteps = [
    {
      id: "personal",
      title: "",
      content: (
        <Step1 stepper={guidedStepper} userUid={id} classYear={classYear} />
      ),
    },
    {
      id: "Uploaddoc1",
      title: "",
      content: (
        <Step2
          stepper={guidedStepper}
          mainAgreement={props.mainType}
          userUid={id}
          userMainAgreement={mainUrl}
        />
      ),
    },
    {
      id: "Uploaddoc2",
      title: "",
      content: (
        <Step3
          transferAgreement={props.transferType}
          athleteAgreement={props.athleteType}
          stepper={guidedStepper}
          userUid={id}
          userSecondAgreement={secondUrl}
        />
      ),
    },
    {
      id: "step4",
      title: "",
      content: (
        <Step4
          stepper={guidedStepper}
          classYear={classYear}
          plans={plans}
          userUid={id}
        />
      ),
    },
    {
      id: "step5",
      title: "",
      content: (
        <Step5
          stepper={guidedStepper}
          selectedPlan={selectedPlan}
          userUid={id}
          paymentType={paymentType}
        />
      ),
    },
    {
      id: "step6",
      title: "",
      content: (
        <Step6
          stepper={guidedStepper}
          userUid={id}
          userDetails={newUser}
          selectedPlan={selectedPlan}
          userMainAgreement={mainUrl}
          userSecondAgreement={secondUrl}
          paymentReceived={paymentDone}
        />
      ),
    },
  ];

  if (!props.auth.isLoaded) {
    return (
      <div className="SpinnerBackground">
        <div className="SpinnerContainer">
          <Loader size="large" active inline="centered" />
        </div>
      </div>
    );
  } else if (props.auth.isEmpty) {
    return <Redirect to="/signup" />;
  } else if (props.role !== "newUser" && props.auth.uid !== props.newUserKey) {
    return (
      <div className="SpinnerBackground">
        <div className="SpinnerContainer">
          <Loader size="large" active inline="centered" />
          {showComponent && (
            <Redirect
              to={
                props.superAdmin ? "/super-admin/" : `/admin/${props.auth.uid}`
              }
            />
          )}
        </div>
      </div>
    );
  } else {
    return (
      <>
        <div className="signupSpacecontainer"></div>
        <div className="signup-container">
          <div className="header-text">
            <h1>Sign Up</h1>
            {paymentRefund && (
              <p className="infoText cu-center">
                <i>
                  <b>
                    {status === null
                      ? "Administrator has set your profile to Pending & "
                      : status === false
                      ? "Administrator have disapprove your request & "
                      : ""}
                    we have refunded the purchased subscription amount.
                  </b>
                </i>
              </p>
            )}
            <div className="card signup-card">
              <div className="card-body signup-card-body">
                {props.emailVerified && paymentDone && (
                  <Step6
                    stepper={guidedStepper}
                    userUid={id}
                    userDetails={newUser}
                    selectedPlan={selectedPlan}
                    userMainAgreement={mainUrl}
                    userSecondAgreement={secondUrl}
                    paymentReceived={paymentDone}
                  />
                )}
                {props.emailVerified && !paymentDone && (
                  <Wizard
                    ref={guidedRef}
                    steps={guidedSteps}
                    options={{
                      linear: false,
                    }}
                    instance={(el) => setGuidedStepper(el)}
                  />
                )}
                {!props.emailVerified && (
                  <>
                    <div className="verify-email">
                      <img src={Verify} alt="Verify" />
                      <h3>We Have Sent You Email To Verify .</h3>
                      <h4>
                        <i>
                          (Please search your Email Inbox with the keywords{" "}
                          <u>"Verify your email for project"</u>.
                          <br /> If the Verification Email is not in your Inbox,
                          please check your Spam or Trash Folders as well.)
                        </i>
                      </h4>
                      <div className="verify-btn-box">
                        <Button
                          icon="send"
                          content="Resend Verification Link"
                          circular
                          loading={props.emailSending}
                          disabled={props.emailSendError || props.emailSent}
                          color="blue"
                          size="large"
                          inverted
                          onClick={() => {
                            dispatch(resendVerfication());
                          }}
                        />
                        <Button
                          content="Next Step"
                          circular
                          inverted
                          loading={props.emailSending}
                          disabled={props.emailSendError || props.emailSent}
                          color="green"
                          size="large"
                          onClick={() => window.location.reload()}
                        ></Button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
};

const mapStateToProps = (state) => {
  let priceList = [];
  let mainType = [];
  let athleteType = [];
  let transferType = [];
  let uid;
  let role;
  let newUserKey;
  let emailSendError = state.signup.verficationEmailSendError;
  let emailSending = state.signup.verficationEmailSending;
  let emailSent = state.signup.verficationEmailSent;

  const priceListData = state.firestore.data.testPriceList;
  const agreementsData = state.firestore.data.testAgreements;

  if (priceListData) {
    const keys = Object.keys(priceListData);
    keys.length > 0 &&
      keys.forEach((key) => priceList.push(priceListData[key]));
  }

  if (agreementsData) {
    const keys = Object.keys(agreementsData);
    keys.length > 0 &&
      keys.forEach((key) => {
        const data = agreementsData[key];
        if (
          data &&
          Object.keys(data).length > 0 &&
          data.type === "main" &&
          data.show
        ) {
          mainType.push(data);
        }
        if (
          data &&
          Object.keys(data).length > 0 &&
          data.type === "athlete" &&
          data.show
        ) {
          athleteType.push(data);
        }
        if (
          data &&
          Object.keys(data).length > 0 &&
          data.type === "transfer" &&
          data.show
        ) {
          transferType.push(data);
        }
      });
  }

  priceList = priceList
    .filter((price) => price && Object.keys(price).length > 0)
    .sort((a, b) => a.amount - b.amount);

  if (state.firebase.auth && state.firestore.data.userRole) {
    uid = state.firebase.auth.uid;
    const keys = Object.keys(state.firestore.data.userRole);
    keys.forEach((key) => {
      if (
        state.firestore.data.userRole[key] &&
        state.firestore.data.userRole[key].userUID === uid
      ) {
        role = state.firestore.data.userRole[key].role;
        if (role === "newUser") {
          newUserKey = uid;
        }
      }
    });
  }

  priceList = priceList.filter((e) => e.show);
  return {
    athleteType,
    auth: state.firebase.auth,
    emailSendError,
    emailSending,
    emailSent,
    emailVerified: state.firebase.auth.emailVerified,
    mainType,
    newRequestCollection: state.firestore.data.testNewRequests,
    newUserKey,
    priceList,
    role,
    superAdmin: state.auth.superAdmin,
    transferType,
  };
};
export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    {
      collection: "testPriceList",
      where: ["show", "==", true],
    },
    {
      collection: "testAgreements",
    },
    {
      collection: "testNewRequests",
    },
    {
      collection: "userRole",
    },
  ])
)(Signup);
